import { Clipboard } from "@angular/cdk/clipboard";
import { Component, Input, ViewChild } from "@angular/core";
import { TooltipDirective } from "ngx-bootstrap/tooltip";

@Component({
  selector: 'clipboard-box',
  template: `
    <div class="clipboard-box" [tooltip]="tooltipTemplate" [isDisabled]="text === '' || text === '-'" container="body" (click)="copyToClipboard()" #tooltip="bs-tooltip">
      <ng-content></ng-content>
      <ng-template #tooltipTemplate>{{ tooltipText | translate }}</ng-template>
    </div>`,
  styles: [`
    .clipboard-box {
      padding: 5px;
    }
  `]
  })
export class ClipboardBoxComponent {
  @Input() text: string;
  @ViewChild('tooltip')  tooltip: TooltipDirective;
  public copied = false;

  constructor(private clipboard: Clipboard) {}

  public get tooltipText(): string {
    return this.copied
      ? 'events.company-call-history.detail.sms.copy-text.copied'
      : 'events.company-call-history.detail.sms.copy-text.copy';
  }

  public copyToClipboard(): void {
    this.clipboard.copy(this.text);
    this.copied = true;
    setTimeout(
      ()=>{
        this.tooltip.hide();
        this.copied = false;
      },
      2000
    );
  }
}
